import { isNil, isString, isObject, isArray, trim } from 'lodash';
import { isPhone } from './env';

const { userAgent } = window.navigator;

/* 中国区号 */
export const CNPhoneCode = 'CN_1';
export const CNPhoneCallingCode = '86';

/* 日本区号 */
export const JPPhoneCode = 'CN_7';
export const JPPhoneCallingCode = '81';

/* 美国、加拿大、美国海外领地区号 */
export const USPhoneCallingCode = '1';

/**
 * 校验是否为中国手机号码
 * 必须 13/14/15/16/17/18/19 开头的 11 位数字
 * @param {string|number} mobile 待验证内容
 */
export const isChinaMobileNumber = (mobile: string | number) => {
    return /^1([3456789])\d{9}$/.test(String(mobile));
};

/**
 * 校验是否为手机号码
 * 非中国手机号必须 6-15 位
 * strict 为 false ,且 mobileCode 为 +86 则只校验第一位为1，且长度 11；
 * 为 true 则校验前三位，如果出现熄灯呢开头可能会出现校验错误的问题
 * @param {string|number} mobile 待验证内容
 * @param {string} mobileCode 区号或者 country code
 */
export const isMobileNumber = (mobile: string, mobileCode: string) => {
    if (mobileCode === CNPhoneCallingCode || mobileCode === CNPhoneCode) {
        return isChinaMobileNumber(mobile);
    }
    return /^\d{6,15}$/.test(mobile);
};

/**
 * 检验验证码是否正确
 * @param code
 */
export const isValidCode = (code: string) => {
    return /^\d{6}$/.test(code);
};

/**
 * 当前客户端浏览器是否为移动端
 */
export const isMobile = () => isPhone;

/**
 * 当前客户端浏览器是否为 PC
 */
export const isPC = () => !isMobile();

export const isIOS = () => {
    return /(iPhone|iPad|iPod|iOS)/i.test(userAgent);
};

export const isAndroid = () => {
    return /(Android)/i.test(userAgent);
};

/* 判断是否是safari */
export const isSafari = () => /Safari/i.test(userAgent) && !/Chrome/i.test(userAgent);

export const isIphoneX = (() => {
    if (typeof window !== 'undefined' && window) {
        return /iphone/gi.test(userAgent) && window.screen.height >= 812;
    }
    return false;
})();

/* 判断是否是「内推官网」 */
export const isReferralPortal = () => {
    return window.location.pathname.startsWith('/referral');
};

// eslint-disable-next-line
const EmailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

/* 判断邮箱是否合法 */
export const isValidEmail = (email: string) => {
    if (isString(email) && EmailRegex.test(email)) {
        return true;
    }
    return false;
};

/* 是否是带了 sdk 的微信 */
export function isWeiXin(): boolean {
    // @ts-ignore-next-line
    const { wx } = window;
    return /micromessenger/.test(userAgent.toLowerCase()) && !!wx;
}

/* 是否是微信浏览器，不判断带没带sdk */
export function isPureWeixin(): boolean {
    return /micromessenger/.test(userAgent.toLowerCase());
}

/* 判断是否为 IE 浏览器 */
export function isIE(): boolean {
    // Internet Explorer 6-11
    // @ts-ignore
    return /* @cc_on!@ */ false || !!document.documentMode;
}

/* 判断是否为 Edge 浏览器 */
export function isEdge(): boolean {
    // Edge 20+
    // @ts-ignore
    return !isIE() && !!window.StyleMedia;
}

export const checkEmpty = (value: any) =>
    isNil(value) ||
    (isString(value) && value === '') ||
    (isObject(value) && Object.keys(value).length === 0) ||
    (isArray(value) && value.length === 0);

/* 判断表单对象是否为空 */
export const isEmptyFormValues = (obj: any): boolean => {
    // @ts-ignore-next-line
    return Object.entries(obj).every(([_, v]) => {
        if (isArray(v) || isObject(v)) {
            return isEmptyFormValues(v);
        }
        if (isString(v)) {
            return trim(v) === '';
        }
        return isNil(v);
    });
};
